import React from "react";
import { arrayOf, func, string, oneOf, shape } from "prop-types";
import Icon from "../Icon/Icon.jsx";
import scTracking from "../SCTracking/sc-tracking.js";

const propTypes = {
  onShare: func,
  orientation: oneOf(["horizontal", "vertical"]).isRequired,
  shares: arrayOf(
    shape({
      type: string.isRequired,
      icon: string.isRequired,
      name: string.isRequired,
    }),
  ).isRequired,
  shareCopy: string,
  shareTitle: string,
};

const ShareIcons = (props) => {
  const { onShare, orientation, shares, shareCopy, shareTitle } = props;

  // og might be undefined, so only get the content if it is defined
  const getContent = (metaTagEl) =>
    metaTagEl ? metaTagEl.getAttribute("content") : "";

  const pageTitle =
    document.querySelector("meta[property='og:title']") ||
    document.querySelector("meta[name='title']");
  const pageDescription =
    document.querySelector("meta[property='og:description']") ||
    document.querySelector("meta[name='description']");

  const pageUrl =
    getContent(document.querySelector("meta[property='og:url']")) ||
    window.location.href;

  const twitterTitle = encodeURIComponent(
    getContent(
      document.querySelector("meta[property='twitter:title']") || pageTitle,
    ),
  );

  const twitterUserRaw = getContent(
    document.querySelector("meta[name='twitter:site']"),
  );

  const twitterUser = twitterUserRaw
    ? `&via=${encodeURIComponent(twitterUserRaw.substring(1))}`
    : "";

  const getDescription = () => {
    if (shareCopy) {
      return encodeURIComponent(shareCopy);
    } else {
      return encodeURIComponent(getContent(pageDescription));
    }
  };

  const title = shareTitle
    ? encodeURIComponent(shareTitle)
    : encodeURIComponent(getContent(pageTitle));

  const url = encodeURIComponent(pageUrl);
  const description = getDescription();

  const getShareUrl = (id) => {
    switch (id) {
      case "twitter":
        // https://dev.twitter.com/web/tweet-button
        if (shareCopy) {
          return `https://twitter.com/intent/tweet?text=${description}&url=${url}${twitterUser}`;
        } else {
          return `https://twitter.com/intent/tweet?text=${twitterTitle}&url=${url}${twitterUser}`;
        }
      case "linkedin":
        return `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${description}`;
      case "facebook":
        // https://developers.facebook.com/tools/debug/sharing/
        return `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}&quote=${description}`;
      case "email":
        // mailto opens default email client
        return description
          ? `mailto:?subject=${title}&body=${description} - ${url}`
          : `mailto:?subject=${title}&body=${url}`;

      case "pinterest":
        //http://pinterest.com/pin/create/button/?url={URI-encoded URL of the page to pin}&media={URI-encoded URL of the image to pin}&description={optional URI-encoded description}">
        return `https://pinterest.com/pin/create/button/?url=${url}&description=${description}`;
      case "whatsapp":
        //http://pinterest.com/pin/create/button/?url={URI-encoded URL of the page to pin}&media={URI-encoded URL of the image to pin}&description={optional URI-encoded description}">
        if (shareCopy) {
          return `https://api.whatsapp.com/send?text=${description} ${url}`;
        } else {
          return `https://api.whatsapp.com/send?text=${title} ${url}`;
        }
    }
  };

  const handleShare = () => {
    if (onShare) onShare();
    scTracking("share");
  };

  return (
    <div className={`share-icons share-icons--${orientation}`}>
      {shares.map((share) => (
        <div className="share-icons__icon-container" key={share.type}>
          <a
            className="share-icons__button"
            href={getShareUrl(share.type)}
            target="_blank"
            title={share.name}
            onClick={handleShare}
            data-action={
              share.type === "whatsapp" ? "share/whatsapp/share" : null
            }
            rel="noopener noreferrer"
          >
            <Icon className="icon--24x24" iconName={share.icon} />
            {share.name}
          </a>
        </div>
      ))}
    </div>
  );
};
ShareIcons.propTypes = propTypes;
export default ShareIcons;
